import { faCalendarXmark } from "@fortawesome/duotone-light-svg-icons"
import { Button } from "@joonapp/web-shared"
import { SessionBooking } from "@joonapp/web-shared"
import { useState } from "react"

const CopySessionLinkButton = ({ session }: { session: SessionBooking }) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopySessionLink = () => {
    const sessionLink = session.meeting_link
    if (!sessionLink) return
    navigator.clipboard.writeText(sessionLink)
    setIsCopied(true)
  }

  return (
    <Button
      text={isCopied ? "Copied!" : "Copy session link"}
      buttonType="secondary"
      onClick={handleCopySessionLink}
      icon={faCalendarXmark}
    />
  )
}

export default CopySessionLinkButton
